import { render, staticRenderFns } from "./ProfileFoundView.vue?vue&type=template&id=f1addc44&scoped=true&"
import script from "./ProfileFoundView.vue?vue&type=script&lang=js&"
export * from "./ProfileFoundView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1addc44",
  null
  
)

export default component.exports